<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
  import emitter from '../../minxins/emitter'
  import {isMeaningful, isMeaningless} from "../../utils/common";
  export default {
    name: "gj-desc-group",
    componentName: 'gj-desc-group',
    mixins: [emitter],
    props: {
      labelWidth: {
        type: String,
        default: null
      },
    },
    data() {
      return {
        descList: [],
      }
    },
    watch: {
      labelWidth(labelWidth) {
        this.descList.forEach(desc => {
          this.updateLabelWidth(desc, labelWidth);
        });
      }
    },
    created() {
      this.$on('gj.descGroup.addDesc', (desc) => {
        this.descList.push(desc);
        this.updateLabelWidth(desc, this.labelWidth);
      });
    },
    methods: {
      updateLabelWidth(desc, labelWidth) {
        if (isMeaningless(desc.labelWidth) && isMeaningful(labelWidth)) {
          desc.proxyLabelWidth = labelWidth;
        }
      }
    }
  }
</script>

<style scoped>

</style>
